<div class="flex-grow" id="toolbox-container-content" #toolboxContainerContent>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>